import React, { Component } from 'react';
import { HTMLTrans } from "../../Common/Translations";
import { roundCurrency } from "../../Common/Helper";

const separator = <hr className='bg-gray-lighten-2'/>;

export default class OrderPaymentDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPaymentDetails: false
    }
  }

  handleClick = () => {
    this.setState((state) => ({showPaymentDetails: !state.showPaymentDetails}));
  }

  render() {
    const {
      currency = '',
      total = 0,
      storeCreditUsed = 0,
      shippingTotal = 0,
      shippingCreditUsed = 0,
      orderTotal = 0,
      paymentMethod = ''
    } = this.props;

    return (
      <div className='d-flex flex-column'>
        <div className='mt-auto'>
          <h4 className='ProximaNova-Bold text-nowrap text-primary-darken-1 text-center text-lg-right mb-0'>{orderTotal}</h4>
          <p className='small text-center text-lg-right mb-0'><HTMLTrans id="account.order_orderpaymentdetails_total">Total</HTMLTrans></p>
        </div>
        <button
          type='button'
          className='btn btn-link btn-sm text-capitalize text-center text-lg-right mt-2 p-0'
          onClick={this.handleClick}
        >
          <u>
            {this.state.showPaymentDetails ?
              <HTMLTrans id="account.order_orderpaymentdetails_hidepaymentdetails">Hide Payment Details</HTMLTrans> :
              <HTMLTrans id="account.order_orderpaymentdetails_viewpaymentdetails">View Payment Details</HTMLTrans>
            }
          </u>
        </button>
        {this.state.showPaymentDetails &&
          <div className='d-flex flex-column mt-2 p-0'>
              <div className='d-flex justify-content-between'>
                <p className='mb-0'><HTMLTrans id="account.order_orderpaymentdetails_shipping_fee">Shipping Fee</HTMLTrans></p>
                <p className='mb-0'>{`${currency} ${roundCurrency(shippingTotal + shippingCreditUsed)}`}</p>
              </div>
              <div>{separator}</div>
              { shippingCreditUsed > 0 &&
                <div>
                  <div className='d-flex justify-content-between'>
                    <p className='mb-0'><HTMLTrans id="account.order_orderpaymentdetails_shipping_credit">Shipping Credit</HTMLTrans></p>
                    <p className='mb-0'>- {`${currency} ${roundCurrency(shippingCreditUsed)}`}</p>
                  </div>
                  {separator}
                </div>
              }
              { storeCreditUsed > 0 &&
                <div>
                  <div className='d-flex justify-content-between'>
                    <p className='mb-0'><HTMLTrans id="account.order_orderpaymentdetails_store_credit">Store Credit</HTMLTrans></p>
                    <p className='mb-0'>- {`${currency} ${roundCurrency(storeCreditUsed)}`}</p>
                  </div>
                  {separator}
                </div>
              }
              <div className='d-flex justify-content-between'>
                <p className='ProximaNova-Bold text-primary mb-0'><HTMLTrans id="account.order_orderpaymentdetails_amount_paid">Amount Paid</HTMLTrans></p>
                <p className='ProximaNova-Bold text-primary mb-0'>{`${currency} ${roundCurrency(total)}`}</p>
              </div>
              <div>{separator}</div>
              <div className='d-flex justify-content-between'>
                <p className='ProximaNova-Bold col-4 m-0 p-0'><HTMLTrans id="account.order_orderpaymentdetails_payment_method">Payment Method</HTMLTrans></p>
                <p className='col-8 m-0 p-0 text-wrap text-right'>{paymentMethod}</p>
              </div>
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Account/Order/OrderPaymentDetails.js